module.exports = "# Sizzle\n\n## Content\n\n### Activity 1: Team Brainstorm!\n\n## Notes\nActivity: Team brainstorm\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* As a team, in two minutes, brainstorm a list of as many words as you can think of that describe water.\n* What does water look, taste, smell, touch, feel like? (eg. \"wet\").\n* One point for each water word!\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/30_classActivity/level1a_teamBrainstorm.md
// module id = 1696
// module chunks = 2